import { acpInterstitialsAppStates } from './states';

export default (appModule) => {
  appModule.config(acpInterstitialsAppStates);
};
